import { Setting } from "../../types/models/Setting";
import {
  NAV_COLLAPSED,
  ROUTE_CHANGE,
  SET_INITIAL_PATH,
  SettingsActionTypes,
  TOGGLE_NAV_COLLAPSED,
  RIS_DEPENDENCY_ERROR,
  OTHER_PROVIDER_ERROR,
  FORGOT_PASSWORD_TOKEN
} from "../../types/actions/Settings.action";

const initialSettings: Setting = {
  navCollapsed: false,
  initialPath: "/",
  invalidToken: undefined,
  otherProviderStatus: undefined,
  forgotPasswordToken: undefined
};

const Settings = (state = initialSettings, action: SettingsActionTypes) => {
  switch (action.type) {
    case ROUTE_CHANGE:
      return {
        ...state,
        navCollapsed: false,
      };

    case TOGGLE_NAV_COLLAPSED:
      return {
        ...state,
        navCollapsed: !state.navCollapsed,
      };

    case SET_INITIAL_PATH:
      return {
        ...state,
        initialPath: action.initialPath,
      };

    case NAV_COLLAPSED:
      return {
        ...state,
        navCollapsed: false,
      };
    case RIS_DEPENDENCY_ERROR:
      return {
        ...state,
        invalidToken: action.payload,
      };
    case OTHER_PROVIDER_ERROR:
      return {
        ...state,
        otherProviderStatus: action.payload,
      };
    case FORGOT_PASSWORD_TOKEN:
      return {
        ...state,
        forgotPasswordToken: action.payload,
      };
    default:
      return state;
  }
};

export default Settings;
